import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {  ModelInvoice } from 'src/app/entities/invoices';
import { ConfigProps, ConfigServiceService } from 'src/app/services/config-service/config-service.service';
import * as $ from 'jquery';
import { UTILS } from 'src/app/entities/Utils';
import { ToastService } from 'src/app/services/toast/toast.service';


import { LoginService, UserData } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/users/user.service';
import { isGetAccessor } from 'typescript';

@Component({
  selector: 'app-dati-ritenuta-cassa-sconti',
  templateUrl: './dati-ritenuta-cassa-sconti.component.html',
  styleUrls: ['./dati-ritenuta-cassa-sconti.component.css']
})
export class DatiRitenutaCassaScontiComponent implements OnInit{ //, OnChanges 
  innerWidth: number | undefined = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  
  @Input() model : ModelInvoice | undefined;
  @Output() modelChange = new EventEmitter<ModelInvoice>();
  
 
  @Output() refreshTotali = new EventEmitter<any>();
  @Output() refreshRiepilogo = new EventEmitter<any>();

  //serve per aggiornare le variabili isDestEstero e isMittenteEstero al fine di non usare l'invasivo ngDoCheck
  @Output() validaCedenteCessionario =  new EventEmitter<any>();
  
  //serve per aggiornale le linee "Fake" utili alla validazione
  @Output() aggiornaFakeLinee = new EventEmitter<any>();

  
  //public SezionaliDisponibili :SezionaliProps[] | undefined;
  public sezionaliAbilitati=false;
  public TipoDocumentoSelezionato: string |undefined;
  public showPercentuale = false;
 
  public configTabs = {
    selected: 1,
    config: [
      {
        id: 1, 
        name: "invoices.edit.cashholdingdiscountsData.other.tabs.tab1"
      },
      {
        id: 2,
        name: "invoices.edit.cashholdingdiscountsData.other.tabs.tab2"
      },
      {
        id: 3,
        name: "invoices.edit.cashholdingdiscountsData.other.tabs.tab3"
      }
    ]
  }

  configProps : ConfigProps | undefined;

  disabledSconti : number[] = [];
  abilitaImponibileCassa: boolean = true;

  constructor(private configService: ConfigServiceService, private modalService: NgbModal, private toastService: ToastService, private loginService: LoginService, private userService: UserService) {
    this.innerWidth = window.innerWidth;
  }


  async ngOnInit() {
    this.configProps = new UTILS().deepCopy(await this.configService.getJSON());
    //let userInfo = await this.loginService.getSessionUserInfo();
    let userInfo: UserData = JSON.parse(localStorage.getItem("einvuser") || "");
    
    // verifica cassa
    if (typeof this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale !== 'undefined') {
      if (typeof this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[0] !== 'undefined') {
        // metto appcassa sulla prima linea
        this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[0].AppCassa = 'SI';
      }

      if (this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length >= 0) {
        for (var i = 0; i < this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length; i++) {
          if (this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[i].PercentualeImponibile != '100') {
            this.showPercentuale = true;
          }
        }
      }
      
    }
    
  }


  ngOnChanges(changes: SimpleChanges): void {
    if(changes.model){
      this.model = changes.model.currentValue;
      this.TipoDocumentoSelezionato = this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento;
    }
  }


  public convalidaRiga(index:number){
    let data = this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[index];
    if((data?.AliquotaRitenuta != '') && (data?.ImportoRitenuta != '') /*&& (data?.TipoRitenuta != '') && (data?.CausalePagamento != '')*/){
      //this.refreshTotali.emit();
      this.refreshRiepilogo.emit();
    }
  }


  // Dati Ritenuta
  public addDatiRitenuta(){
    /*let message="Aggiungi almeno un bene o un servizio con aliquota iva maggiore di 0";
    let datiRiepilogo=this.model?.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo;
    if( datiRiepilogo?.filter(dR => dR.AliquotaIVA != "" && dR.AliquotaIVA != "0.00").length == 0 ){
      this.toastService.openToastWithConfig(false, 0, message, 'warning');
      return;
    }*/

    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta;
    if(list?.filter(l => l.AliquotaRitenuta == "" || l.CausalePagamento == "").length == 0){
      list.push({AliquotaRitenuta: "20.00", CausalePagamento: "", ImportoRitenuta: "", TipoRitenuta: "", PercentualeImponibile: "100"});
      //se è l'unica riga di dati ritenuta, imposto Ritenuta=SI alle linee idonee
      if(this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length==1){
        let linee=this.model?.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;
        let trovato=false;
        for(var i=0; i<linee.length; i++){
          if(linee[i].Quantita!='0.00' && linee[i].PrezzoUnitario!='0.00' && linee[i].AliquotaIVA != "" /*&& linee[i].AliquotaIVA != "0.00"*/ ){
              linee[i].Ritenuta='SI';
              trovato =true;
          }
        }
        if(trovato) {
          //emitt evento Modifica Linee /Aggiornamento fakeLinee
          this.aggiornaFakeLinee.emit();
        }
      }
      this.refreshRiepilogo.emit();
    }
  }


  public deleteDatiRetenuta(index: number){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta;
    list?.splice(index, 1);
    if(this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length==0){
      let linee=this.model?.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;
      for(var i=0; i<linee.length; i++){
            linee[i].Ritenuta='';
      }
       //emitt evento Modifica Linee /Aggiornamento fakeLinee
       this.aggiornaFakeLinee.emit();
    }
    this.refreshTotali.emit();
  }


  // Cassa Previdenziale
  public addCassaPrevidenziale(){
    let message="Non trovo alcun bene o servizio idoneo al calcolo della cassa previdenziale";
    let datiRiepilogo=this.model?.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo;
    if( datiRiepilogo?.filter(dR => dR.AliquotaIVA != "" && dR.Natura != "N1").length == 0 ){
      this.toastService.openToastWithConfig(false, 0, message, 'warning');
      return;
    }

    let aliquotaIva=datiRiepilogo![0].AliquotaIVA;
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale;
    if(list?.filter(l => l.TipoCassa == "" || l.ImportoContributoCassa == 0).length == 0){

      let linee=this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;
      let totale :number =0;

      if(this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length==0){
          //controllo tutte le righe ed abilito cassa qualora la riga fosse valida.
          //operazione valida solo per l'inserimento della prima riga della cassa previdenziale
          let trovato=false;
          for(var i=0; i<linee.length; i++){
              if(linee[i].Natura!="N1"){
                linee[i].AppCassa='SI';
                trovato=true;
                totale=totale + parseFloat("" +linee[i].PrezzoTotale);
              }else linee[i].AppCassa='NO';
          }
          if(trovato)
              this.aggiornaFakeLinee.emit();
      }else{
          for(var i=0; i<linee.length; i++)
              if(linee[i].AppCassa=='SI')
                  totale=totale + parseFloat("" +linee[i].PrezzoTotale);
      }
     let ImponibileCassa = Number(totale).toFixed(2);
     list.push({AlCassa: 0, AliquotaIVA: aliquotaIva,ImponibileCassa: ImponibileCassa, ImportoContributoCassa: 0, Natura: "", RiferimentoAmministrazione: "", Ritenuta: "",TipoCassa: ""});
    } 
    this.notifyChange(); 
  }

  public deleteCassaPrevidenziale(index: number){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale;
    list?.splice(index, 1);
    if(list?.length==0){
      let linee=this.model!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;
      for(var i=0;i<linee.length;i++)
            linee[i].AppCassa='';
      this.aggiornaFakeLinee.emit();
    }
    this.refreshRiepilogo.emit();
  }



  // Causali
  public addCausale(){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale;
    if(list?.filter(l => l == "").length == 0){
      list.push("");
    }else{
      this.toastService.openToastWithConfig(false, 0, "Compila prima la riga esistente", 'warning');
    }
  }

  public setCausale(index: number, event: any){
    let list = this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale;
    let val=event.target.value.toUpperCase();
    if(val.length==0)
      list.splice(index,1);
    else
      list[index] = event.target.value.toUpperCase();
  }

  public deleteCausale(index: number){
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale;
    list?.splice(index, 1);
  }


  public async notifyChange(){
    await this.modelChange.emit(this.model);
  }

    // Sconto / Maggiorazione
    public addScontoMaggiorazione(){
      let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione;
      if(list?.filter(l => l.Tipo == "" || (l.Percentuale == '0.00' && l.Importo == '0.00')).length == 0){
        list.push({Tipo: 'SC', Importo: '0.00', Percentuale: '0.00'});
      }
    }
  
    public deleteScontoMaggiorazione(index: number){
      this.disabledSconti.splice(this.disabledSconti.indexOf(index), 1);
      let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione;
      list?.splice(index, 1);
      this.refreshRiepilogo.emit();
    }

  validaSconto(row: {Tipo: string, Percentuale: string, Importo: string}, indexRow: number){
    if((Number.parseFloat(row.Percentuale) >0 ) || (Number.parseFloat(row.Importo)>0)){
        if ((+row.Percentuale > 0) && (+row.Importo > 0)) {
                alert('Attenzione percentuale presente importo non imputabile');
            }
         // this.calcolaSconto(row,indexRow);
          this.disabledSconti.push(indexRow);
          this.refreshRiepilogo.emit();
      }      
  }



  calcolaSconto(row: {Tipo: string, Percentuale: string, Importo: string}, indexRow: number) {
    
    if(this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length > 0){
      var importoTotale = this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento;

      // Controllo che ambedue i campi non siano pieni
      if ((+row.Percentuale > 0) && (+row.Importo > 0)) {
          alert('Attenzione percentuale presente importo non imputabile');
      }
      var tot = 0;
      // Controllo Importo sconto se presente
      if ((+row.Importo > 0) && (+row.Percentuale == 0.00)) {

          // check datiRiepilogo
          var dR = this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[0];
          var imponibile = this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[0].ImponibileImporto;

          // C'è importo sconto calcola il nuovo totale in base all'importo dello sconto
          if (row.Tipo == "SC") {
              if (dR.EsigibilitaIVA == "S") {
                  // se c'è lo split payment lo sconto si applica all'imponibile, non all'importo totale
                  tot = (Number.parseFloat(imponibile) - Number.parseFloat(row.Importo));
              } else {
                  tot = (Number.parseFloat(importoTotale) - Number.parseFloat(row.Importo));
              }
              
          } else if (row.Tipo == "MG") {
              if (dR.EsigibilitaIVA == "S") {
                  // se c'è lo split payment lo sconto si applica all'imponibile, non all'importo totale
                  tot = (Number.parseFloat(imponibile) - Number.parseFloat(row.Importo));
              } else {
                  tot = (Number.parseFloat(importoTotale) + Number.parseFloat(row.Importo));
              }
              
          }
      }

      if ((+row.Importo == 0.00) && (+row.Percentuale > 0)) {
          // check datiRiepilogo
          var dR = this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[0];
          var imponibile = this.model!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[0].ImponibileImporto;
          var PrezzoUnitarioCalcolato = 0;
          // C'è percentuale sconto calcola il nuovo totale in base alla percentuale
          if (row.Tipo == "SC") {
              if (dR.EsigibilitaIVA == "S") {
                  // se c'è lo split payment lo sconto si applica all'imponibile, non all'importo totale
                  PrezzoUnitarioCalcolato = Number.parseFloat(imponibile) - ((Number.parseFloat(imponibile) * Number.parseFloat(row.Percentuale)) / 100);
              } else {
                  PrezzoUnitarioCalcolato = Number.parseFloat(importoTotale) - ((Number.parseFloat(importoTotale) * Number.parseFloat(row.Percentuale)) / 100);
                  
              }
              
          } else if (row.Tipo == "MG") {
              if (dR.EsigibilitaIVA == "S") {
                  // se c'è lo split payment lo sconto si applica all'imponibile, non all'importo totale
                  PrezzoUnitarioCalcolato = Number.parseFloat(imponibile) - ((Number.parseFloat(imponibile) * Number.parseFloat(row.Percentuale)) / 100);
              } else {
                  PrezzoUnitarioCalcolato = Number.parseFloat(importoTotale) + ((Number.parseFloat(importoTotale) * Number.parseFloat(row.Percentuale)) / 100);
              }
              
          }

          tot = (Number.parseFloat("" + PrezzoUnitarioCalcolato));
      }

      // self.isDisabled[riga] = true;
      //this.einvoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento = parseFloat(tot);
      this.model!.FatturaElettronicaBody.DatiPagamento[0].DettaglioPagamento.ImportoPagamento = "" + parseFloat("" + tot);
      this.disabledSconti.push(indexRow);
    }
  }


  calculateCassa(cass: {AlCassa: number; AliquotaIVA: string;ImponibileCassa: string;ImportoContributoCassa: number;Natura: string;RiferimentoAmministrazione: string; Ritenuta: string;TipoCassa: string;}){
    let tot = parseFloat((cass.ImponibileCassa as string) != '' ? (cass.ImponibileCassa as string) : "0") * parseFloat("" + cass.AlCassa) / 100;
    cass.ImportoContributoCassa = parseFloat(Number(tot).toFixed(2));
  }

  abilitaImponibileCassaPrev() {
    this.abilitaImponibileCassa = false;
  }


  public resetDisabledSconti(){
    this.disabledSconti = [];
  }


}
